module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_more2.f8bd1.png";